export default __webpack_public_path__ + "static/qr-weixin-f7075900f79be2f9b8fb26f529b0fa66.jpg";